import { getMailStopApi, MailStopApiRequest, MailStopApiResponse } from '@common/external/MailStopApi';
import { getMailDeliveryStopApi, MailDeliveryStopApiRequest, MailDeliveryStopApiResponse } from '@common/external/MailDeliveryStopApi';

export async function getMailStop(request: MailStopApiRequest): Promise<MailStopApiResponse> {
  const response: MailStopApiResponse = await getMailStopApi(request);
  return response;
}

export async function getMailDeliveryStop(request: MailDeliveryStopApiRequest): Promise<MailDeliveryStopApiResponse> {
  const response: MailDeliveryStopApiResponse = await getMailDeliveryStopApi(request);
  return response;
}
